<template>
<vs-row align="center">
    <div align="center">
        <div style="font-style: italic; color: #444; background-color: #fff8e1; padding: 10px; border-left: 5px solid #f1c40f; border-radius: 5px;">
            ⚠️ <strong>El stock de algunos productos no se puede cambiar ya que quedarían con cantidades negativas en facturas, notas o stock general.
            </strong>
        </div>
    </div>
    <!-- {{ erroresStock_Lista }} -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
        <table class="tabla-errores">
            <tbody>
                <!-- Iterar sobre los productos insuficientes -->
                <template v-for="(producto, i) in erroresStock_Lista.productos_insuficientes">
                    <tr :key="'producto-' + i">
                        <td colspan="5" class="celda-header">
                            <strong>Producto: {{ producto.pro_codigo }}</strong>
                        </td>
                    </tr>
                    <!-- Iterar sobre los detalles (stock y reservar) -->
                    <tr v-for="(detalle, tipo) in producto.detalles" :key="producto.pro_codigo + '-' + tipo">
                        <td width="80">
                            <strong>
                                <!-- Asignar texto según el tipo -->
                                <span v-if="tipo == 'stock'">Stock Facturas</span>
                                <span v-else-if="tipo == 'deposito'">Stock Notas</span>
                                <span v-else-if="tipo == 'reservar'">Stock General</span>
                            </strong>
                        </td>
                        <td><strong>Solicitado:</strong> {{ detalle.solicitado }}</td>
                        <td><strong>Anterior:</strong> {{ detalle.antiguo }}</td>
                        <td><strong>Actual:</strong> {{ detalle.actual }}</td>
                        <td><strong>Faltante:</strong> {{ Math.abs(detalle.faltante) }}</td>
                    </tr>
                </template>
            </tbody>
        </table>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-6">
        <vs-button @click="getAceptarInformacion()" type="relief">Cerrar</vs-button>
    </vs-col>
</vs-row>
</template>

<script>
import vSelect from "vue-select";
export default {
    data() {
        return {
            //showAgregarNuevo: false,
            // erroresStock_Lista_Modificado: '',
        };
    },
    components: {
        "v-select": vSelect,
    },
    props: {
        erroresStock_Lista: {
            type: Object,
            default: function () {
                return {}
            }
        },
    },
    mounted() {},
    methods: {

        getAceptarInformacion() {
            this.$emit('change', {
                verificacionemitdeerrorlistado: 2
            });
        },
    },
};
</script>

<style scoped>
.tabla-errores {
    border-collapse: collapse;
    width: 100%;
}

.tabla-errores td {
    padding: 4px;
    /* Espacio dentro de cada celda */
    border: 1px solid #ddd;
    /* Borde ligero */
}

.celda-header {
    background-color: #f4f4f4;
    font-weight: bold;
    text-align: center;
}
</style>
